export default "__VITE_ASSET__DxKjMLCw__"